import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit, OnDestroy {
    location: any;
    isRedesign = false;
    routerSubscription: any;

    constructor(private router: Router) {
    }

    ngOnInit() {
        $.getScript('assets/js/custom.js');
        this.recallJsFuntions();
    }

    recallJsFuntions() {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    //$('.preloader').fadeIn('slow');
                }
            });
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                $.getScript('assets/js/custom.js');
                //$('.preloader').fadeOut('slow');
                this.location = this.router.url;
                this.isRedesign =  true; //this.location.includes('-redesign');
                
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                //window.scrollTo(0, 0)
            });
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }

    onActivate(event) {
        window.scroll({ 
                top: 0, 
                left: 0, 
                behavior: 'smooth' 
         });
     }
}
